import {createContext, useEffect, useState} from "react";
import Sidebar, {SidebarTab} from "../../components/Sidebar";
import TechnologiesMap from "../../components/TechnologiesMap";
import {
  initialStateFintechDataIds,
  initialStateFintechFilters,
  initialStateFintechWeakSignalsFilters,
  // initialStateFintechWeakSignalsFilters,
} from "./FintechDashboard.const";
import {DashboardContainer, TopBarContainer} from "./FintechDashboard.styles";
// import DataJson from "../../data/DataFintech.json";
import DataWeakSignalsJson from "../../data/weak_signals.json";
import {
  IFintechDataIds,
  IFintechWeakSignalsFilters,
  IinitialStateServerFintech,
} from "./FintechDashboard.type";
import SidebarCard from "../../components/SidebarCard";
import RadarChart from "../../components/RadarChart/RadarChart";
import useFinTechFilteredData from "../../hooks/useFinTechFilteredData";
// import ClusterFintechWeaksignal from "../../components/ClusterFilter/ClusterFintechWeaksignal";
import ClusterFilter from "../../components/ClusterFilter";
import SidebarInfo from "../../components/SidebarInfo";
import {ITypeRadar} from "../../types";
import {SidebarCardContainer} from "../../ui/SidebarCardContainer";
import {apiKeyDataFintech, urlApiDataFintech} from "../../helper/api";
import useFetchDataFintech from "../../hooks/useFetchDataFintech";
import {AboutRadarTop} from "../../components/AboutRadarTop/AboutRadarTop";

export const DataFintechIdsContext = createContext<any>(null);

interface Iprops {
  isWeakSignals?: boolean;
}

const FintechDashboard: React.FC<Iprops> = ({isWeakSignals = false}) => {
  const apiUrlTrends = `${urlApiDataFintech}/api/trends`;
  const apiUrlSectors = `${urlApiDataFintech}/api/sectors`;

  const [isShowAllLabels, setIsShowAllLabels] = useState(true);
  if (!apiKeyDataFintech) {
    throw new Error("API key не тот");
  }
  const {trendsData, sectorsData, weakSignalsData, weakSegmentsData} =
    useFetchDataFintech(apiUrlTrends, apiUrlSectors, apiKeyDataFintech);

  const [activeSidebarTab, setActiveSidebarTab] = useState<SidebarTab>(
    SidebarTab.Empty
  );
  const dataFromJson: IinitialStateServerFintech = JSON.parse(
    JSON.stringify({
      // ...DataJson,
      // ...DataWeakSignalsJson,
      directions: sectorsData?.data || [],
      trends: trendsData?.data || [],
      weak_signals:
        weakSignalsData?.data?.length
          ? weakSignalsData.data
          : DataWeakSignalsJson.weak_signals,
      weaksignalsSegments:
        weakSegmentsData?.data?.length
          ? weakSegmentsData.data
          : DataWeakSignalsJson.segments,
    })
  );

  const searchDatasidebarInfo = {
    directions: dataFromJson.directions.map((item) => {
      return {id: item.id, name: item.name};
    }),
    clusters: dataFromJson.trends
      .filter((item) => item.sector !== null)
      .map((item) => {
        return {
          id: item.id === null ? 2 : item.documentId,
          name: item.name,
          direction_id: item.sector.id,
        };
      }),
    weak_signals: dataFromJson.weak_signals.map((item) => {
      return {
        id: item.id,
        name: item.title,
        direction_id: item.segment_id,
      };
    }),
    weaksignalsSegments: dataFromJson.weaksignalsSegments.map((item) => {
      return {id: item.segment_id, name: item.segment};
    }),
  };

  const [isOpenPanel, setIsOpenPanel] = useState(false);
  const [isOpenSideBar, setIsOpenSideBar] = useState<boolean>(false);
  const [isOpenSideBarInfo, setIsOpenSideBarInfo] = useState<boolean>(false);
  const [isVisibleFiltersPanel, setIsVisibleFiltersPanel] = useState(false);

  const [isSearchPanelActive, setIsSearchPanelActive] = useState(false);
  const [filters, setFilters] = useState(initialStateFintechFilters);
  const [filterWeakSignals, setFilterWeakSignals] =
    useState<IFintechWeakSignalsFilters>(initialStateFintechWeakSignalsFilters);
  const [cpuStep, setCpuStep] = useState(1);
  const [activeTab, setActiveTab] = useState(SidebarTab.Directions);
  const [activeClusterId, setActiveClusterId] = useState<
    number | string | null | undefined
  >();
  const [activeDirectionId, setActiveDirectionId] = useState<
    number | string | null | undefined
  >();

  const radarData = useFinTechFilteredData(
    dataFromJson,
    filters,
    filterWeakSignals
  );

  const [dataIds, setDataIds] = useState<IFintechDataIds>(
    initialStateFintechDataIds
  );

  useEffect(() => {
    setFilterWeakSignals((prevFilters: any) => ({
      ...prevFilters,
      weak_signal: {
        ...prevFilters.weak_signal,
        value: isWeakSignals,
      },
    }));
  }, [isWeakSignals]);

  useEffect(() => {
    if (activeSidebarTab === SidebarTab.Directions) {
      setActiveTab(SidebarTab.Directions);
    }
    if (activeSidebarTab === SidebarTab.Projects) {
      setActiveTab(SidebarTab.Directions);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.CPU) {
      cpuStep === 1
        ? setActiveTab(SidebarTab.Projects)
        : setActiveTab(SidebarTab.CPU);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.Trends) {
      setActiveTab(SidebarTab.Trends);
      setIsOpenSideBar(true);
    }
    if (activeSidebarTab === SidebarTab.WeakSignal) {
      setActiveTab(SidebarTab.WeakSignal);
      setIsOpenSideBar(true);
    }
  }, [activeSidebarTab, cpuStep]);

  const openSidebarWithTab = (
    tab: SidebarTab,
    directionId: number | string,
    trendId?: number | string,
    trendTitle?: string,
    sectionName?: string,
    segmentColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: number | string,
    typeRadar?: ITypeRadar,
    isSearchPanelActive?: boolean
  ) => {
    setCpuStep(1);
    setActiveClusterId(trendId);
    setActiveDirectionId(directionId);
    setDataIds({
      directionId,
      trendId: trendId !== undefined ? trendId : null,
      trendName: trendTitle || "",
      directionName: sectionName || "",
      colorTitle: segmentColor?.back || "",
    });
    setActiveSidebarTab(tab);
    setIsOpenSideBar(true);

    setIsOpenPanel(false);
    if (isSearchPanelActive) {
      setIsSearchPanelActive(true);
    } else {
      setIsSearchPanelActive(false);
    }
  };

  const resetToDefaultTab = () => {
    if (isSearchPanelActive) setIsOpenPanel(true);
    setTimeout(() => {
      setActiveSidebarTab(SidebarTab.Directions);
      setCpuStep(1);
      setActiveClusterId(null);
      setActiveDirectionId(null);
    }, 600);
    setDataIds({
      directionId: null,
      trendId: null,
      trendName: "",
      directionName: "",
      colorTitle: "",
    });
    setIsOpenSideBar(false);
  };

  const toggleFilter: <T>(
    filter?: string,
    value?: T,
    isReset?: boolean
  ) => void = (filter, value, isReset = false) => {
    if (isWeakSignals) {
      if (isReset) {
        setFilterWeakSignals(initialStateFintechWeakSignalsFilters);
        return;
      }
      if (!filter) return;
      if (!(filter in initialStateFintechWeakSignalsFilters)) return;
      setFilterWeakSignals((prevFilters: any) => ({
        ...prevFilters,
        [filter]: {
          value: value !== undefined ? value : !prevFilters[filter],
          turnOn:
            value === undefined ||
            value ===
              initialStateFintechWeakSignalsFilters[
                filter as keyof typeof initialStateFintechWeakSignalsFilters
              ].value
              ? false
              : true,
        },
      }));
    } else {
      if (isReset) {
        setFilters(initialStateFintechFilters);
        return;
      }
      if (!filter) return;
      if (!(filter in initialStateFintechFilters)) return;
      setFilters((prevFilters: any) => ({
        ...prevFilters,
        [filter]: {
          value: value !== undefined ? value : !prevFilters[filter],
          turnOn:
            value === undefined ||
            value ===
              initialStateFintechFilters[
                filter as keyof typeof initialStateFintechFilters
              ].value
              ? false
              : true,
        },
      }));
    }
  };
  return (
    <DataFintechIdsContext.Provider value={{dataIds, setDataIds}}>
      <DashboardContainer>
        <Sidebar
          activeTab={activeTab}
          typeRadar={filterWeakSignals.weak_signal ? "weak_signals" : "fintech"}
          setIsOpenSideBarInfo={setIsOpenSideBarInfo}
          isOpenSideBarInfo={isOpenSideBarInfo}
          searchDatasidebarInfo={searchDatasidebarInfo}
          setIsOpenPanel={setIsOpenPanel}
          isOpenPanel={isOpenPanel}
          openSidebarWithTab={openSidebarWithTab}
          onFilterChange={toggleFilter}
          filters={filters}
          isVisibleFiltersPanel={isVisibleFiltersPanel}
          setIsVisibleFiltersPanel={setIsVisibleFiltersPanel}
          isShowAllLabels={isShowAllLabels}
          setIsShowAllLabels={setIsShowAllLabels}
          isOpenSideBar={isOpenSideBar}
        />

        <SidebarCardContainer isOpenSideBar={isOpenSideBar}>
          <SidebarCard
            activeTab={activeSidebarTab}
            resetToDefaultTab={resetToDefaultTab}
            setActiveTab={setActiveSidebarTab}
            cpuStep={cpuStep}
            setCpuStep={setCpuStep}
            typeRadar={
              isSearchPanelActive
                ? activeSidebarTab === "Trends"
                  ? "fintech"
                  : "weak_signals"
                : filterWeakSignals.weak_signal.value
                ? "weak_signals"
                : "fintech"
            }
            colorTitle={dataIds.colorTitle}
          />
        </SidebarCardContainer>

        <SidebarCardContainer isOpenSideBar={isOpenSideBarInfo}>
          <SidebarInfo typeRadar="fintech" close={setIsOpenSideBarInfo} />
        </SidebarCardContainer>

        <TopBarContainer>
          <AboutRadarTop typeRadar={"fintech"} />
          <TechnologiesMap
            typeRadar={
              filterWeakSignals.weak_signal.value ? "weak_signals" : "fintech"
            }
          />
        </TopBarContainer>

        <RadarChart
          openSidebarWithTab={openSidebarWithTab}
          radarData={radarData}
          activeClusterId={activeClusterId}
          activeDirectionId={activeDirectionId}
          typeRadar="fintech"
          filters={filters}
          isWeak_signal={filterWeakSignals.weak_signal.value}
          isShowAllLabels={isShowAllLabels}
          // signal_trend={filterWeakSignals.weak_signal_trend}
        />
      </DashboardContainer>
    </DataFintechIdsContext.Provider>
  );
};

export default FintechDashboard;
